var React = require('react');

function Check2 (props) {
    return React.createElement("svg",props,React.createElement("g",{"data-name":"Check icon"},React.createElement("path",{"fill":"none","stroke":"#ffffff","strokeLinecap":"round","strokeWidth":"3","d":"m32.448 14.903-13.75 16.062-5.549-5.653","data-name":"Path 533"})));
}

Check2.defaultProps = {"viewBox":"0 0 45.566 45.566"};

module.exports = Check2;

Check2.default = Check2;
